import React from 'react'
import BillPayAll from 'src/app/BillPayAll/BillPayAll'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { billPayAllRouteProps } from 'src/navigation/routeProps'

const BillPayAllAppRoute: AppRoute = {
  id: AppLocation.BillPayAll,
  routeProps: billPayAllRouteProps,
  component: <BillPayAll />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default BillPayAllAppRoute
